import {UyapRequest} from "./UyapRequest";

export interface MtsTebligatSafahatListTalep {
    barkodNo: string    //mersule
}

export type MtsTebligatSafahatListCevap = MtsTebligatSafahatListRow[];


export interface MtsTebligatSafahatListRow {
    aciklama: string,
    islemYeri: string,
    safahatKodu: number,
    siraNo: number,
    tarih: string
}

export default class MtsTebligatSafahatList extends UyapRequest<MtsTebligatSafahatListTalep, MtsTebligatSafahatListCevap> {
    getMethod(): 'GET' | 'POST' {
        return 'POST';
    }

    getSpinnerMessage(){
        return "MTS tebligat safahat listesi sorgulanıyor...";
    }


    cache() {
        return {
            active: false,
            ttl: (60 * 24), //* 1 gun
            key: "_"
        };
    }

    getMockResponse(): Array<MtsTebligatSafahatListRow> {
        return [{"aciklama":"Tebligat basım için hazırlanıyor","islemYeri":"","safahatKodu":0,"siraNo":0,"tarih":"20251118"},{"aciklama":"Kabul Edildi","islemYeri":"ANKARA PİM/ANKARA PİM","safahatKodu":0,"siraNo":1,"tarih":"19/11/2025"},{"aciklama":"Gönderinin Geliş Kaydı Yapıldı","islemYeri":"ANKARA PİM/ANKARA PİM","safahatKodu":0,"siraNo":2,"tarih":"19/11/2025"},{"aciklama":"Torbaya Eklendi","islemYeri":"ANKARA PİM/ANKARA PİM","safahatKodu":0,"siraNo":3,"tarih":"19/11/2025"},{"aciklama":"Gönderinin Geliş Kaydı Yapıldı","islemYeri":"ANTALYA PKİM/ANTALYA PKİM","safahatKodu":0,"siraNo":4,"tarih":"20/11/2025"},{"aciklama":"Torbaya Eklendi","islemYeri":"ANTALYA PKİM/ANTALYA PKİM","safahatKodu":0,"siraNo":5,"tarih":"20/11/2025"},{"aciklama":"Gönderinin Geliş Kaydı Yapıldı","islemYeri":"AKDENİZ SANAYİ  PKDM/AKDENİZ SANAYİ  PKDM","safahatKodu":0,"siraNo":6,"tarih":"20/11/2025"}];
    }

    getUrl(): string {
        return this.ImzaClientAddr + 'mts_tebligat_safahat_list_brd.ajx';
    }

    async parse(data: any): Promise<MtsTebligatSafahatListCevap> {
        return data
    }

}
